"use client";
import React, { useEffect, useState } from "react";
import { Link, useRouter } from "@/navigation";
import { useTranslations } from "next-intl";
import { ProductListItemFragment } from "@/gql/graphql";
import { useLoveStore } from "@/lib/store/love.store";
import clsx from "clsx";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // 需要引入样式
import { productTranslationName } from "@/lib/utils/util";
import { useCompareStore } from "@/lib/store/Compare.store";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";
import CustomImage from "../Image";
export type ImgObj = {
	id?: number;
	url: string;
	name: string;
	type: string;
};
export type Metadata = { __typename?: "MetadataItem" | undefined; key: string; value: string };
export const filterCateImg = (metadataList: Metadata[]) => {
	let imgUrlList: ImgObj[] = [];
	if (metadataList && metadataList.length > 0) {
		const media = metadataList.filter((i: Metadata) => i.key === "media");
		if (media.length > 0) imgUrlList = JSON.parse(media[0].value) as ImgObj[];
	}
	return imgUrlList;
};
type dscObj = {
	data: { text: string };
	type: string;
};
type dscList = {
	blocks: dscObj[];
};

export const filterSortDsc = (dsc: string) => {
	let sortDsc = "";
	let longDsc = "";
	if (dsc) {
		const dscObj = JSON.parse(dsc) as dscList;

		if (dscObj && dscObj.blocks.length > 0) {
			sortDsc = dscObj.blocks[1].data.text;
			longDsc = dscObj.blocks[0].data.text;
		}
	}

	return { sortDsc, longDsc };
};

const handlerInnerHtml = (html: string): string => {
	if (!html) return html;
	return html
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&#8216;/g, "'")
		.replace(/&#8217;/g, "'")
		.replace(/&#8211;/g, "–")
		.replace(/&nbsp;/g, " ");
};
export default function ProductCard({
	productItem,
	locale,
  twoCol
}: {
	productItem: ProductListItemFragment;
	locale: string;
  twoCol?:boolean
  
}) {
	const router = useRouter();
	const [isOpen, setIsOpen] = useState(false);
	const [imageUrl, setimageUrl] = useState(""); // 替换为你的图片 URL
	let { compareIds, show, changeShow, setcCmpareProducts } = useCompareStore();
	const t = useTranslations();
	const { openModalInquiry } = useModalInquiryContext();

	const pt = productItem.media;
	const imgs = JSON.parse(pt) || [];
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const [isHovered, setIsHovered] = useState(false); // 控制动画容器状态
	const handleMouseEnter = () => {
		setIsHovered(true);
		setCurrentImageIndex(0); // 切换到第二张图片
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
		setCurrentImageIndex(0); // 切换回第一张图片
	};

	// 添加对比
	const addOrDelCompare = (event: React.MouseEvent, product) => {
		event.stopPropagation();
		// console.log(product, "product");

		const id = product?.id;
		if (id) {
			setcCmpareProducts(id);
			changeShow(true);
		}
	};
	let html =filterSortDsc(productItem?.translation?.descriptionJson).sortDsc ||
				filterSortDsc(productItem?.descriptionJson).sortDsc;
	let ProductName = productTranslationName(productItem?.translation?.name)|| productTranslationName(productItem?.name);
	return (
		<Link
			href={"/product/" + productItem.slug}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			className={clsx(
				"group relative flex flex-col w-full bg-white shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100",
				twoCol ? "h-[770px]" : "h-[500px]"
			)}
		>
			{/* hover时边框从右下角延伸动画 */}
			<div className="absolute inset-0 pointer-events-none z-30">
				{/* 右边框 - 从下往上延伸 */}
				<div className="absolute bottom-0 right-0 w-[2px] h-0 bg-mainColor group-hover:h-full transition-all duration-500 ease-out" style={{ transitionDelay: '0s' }}></div>
				{/* 下边框 - 从右往左延伸 */}
				<div className="absolute bottom-0 right-0 w-0 h-[2px] bg-mainColor group-hover:w-full transition-all duration-500 ease-out" style={{ transitionDelay: '0.25s' }}></div>
				{/* 左边框 - 从下往上延伸 */}
				<div className="absolute bottom-0 left-0 w-[2px] h-0 bg-mainColor group-hover:h-full transition-all duration-500 ease-out" style={{ transitionDelay: '0.5s' }}></div>
				{/* 上边框 - 从右往左延伸 */}
				<div className="absolute top-0 right-0 w-0 h-[2px] bg-mainColor group-hover:w-full transition-all duration-500 ease-out" style={{ transitionDelay: '0.75s' }}></div>
			</div>
			
			{/* 图片区域 */}
			<div className={clsx("relative w-full overflow-hidden bg-white flex items-center justify-center", twoCol ? "h-[450px]" : "h-[400px]")}>
				<CustomImage
					fill
					quality={70}
					alt={ProductName}
					className="object-contain group-hover:scale-110 transition-transform duration-300"
					src={imgs[0]?.url || "/image/default-image2.webp"}
					sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
				/>
			</div>

			{/* hover时黑色遮罩层 */}
			<div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-40 pointer-events-none"></div>

			{/* hover时显示在中间的按钮 */}
			<div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 pointer-events-none">
				<div className="flex gap-4 max-md:flex-col max-md:gap-3 pointer-events-auto">
					<button
						type="button"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							// 打开询盘弹窗
							openModalInquiry(false);
						}}
						aria-label={`${t('base.getInstantQuote')} for ${productItem.name}`}
						className="bg-mainColor text-white py-3 px-6 rounded-md hover:bg-mainColor/90 transition-colors duration-200 text-sm font-medium whitespace-nowrap"
					>
						{t('base.getInstantQuote')}
					</button>
					<button
						type="button"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							// 使用 router 跳转，避免嵌套 <a> 标签
							router.push("/product/" + productItem.slug);
						}}
						aria-label={`${t('resource.View More')} ${productItem.name}`}
						className="border-2 border-white text-white py-3 px-6 rounded-md hover:bg-white hover:text-mainColor transition-colors duration-200 text-sm font-medium text-center whitespace-nowrap"
					>
						{t('resource.View More')}
					</button>
				</div>
			</div>

			{/* 产品信息 - 在图片下方 */}
			<div className="flex flex-col flex-1 p-5 max-md:p-4 relative z-10">
				<div className="flex-1">
					<h3 className="text-xl font-bold text-black mb-3 group-hover:text-mainColor transition-colors line-clamp-2 min-h-[3rem]">
						{ProductName}
					</h3>
					{/* 简述 */}
					{html && (
						<div className="mb-4">
							<p 
								className="text-sm text-gray-600 line-clamp-3 leading-relaxed"
								dangerouslySetInnerHTML={{ __html: handlerInnerHtml(html) }}
							></p>
						</div>
					)}
				</div>
				{/* 分隔线和定制文字 - 固定在底部 */}
				<div className="mt-auto pt-3 border-t border-gray-200">
					<p className="text-[10px] text-mainColor text-center opacity-70">
						{t('plsyy.Can-be-customized')}
					</p>
				</div>
			</div>

			{isOpen && <Lightbox mainSrc={imageUrl} onCloseRequest={() => setIsOpen(false)} />}
		</Link>
	);
}

export function IconLove(props: { product?: any }) {
	let product = props.product;

	const [isLove, setIsLove] = useState(false);
	const { loveIds, setLoveProducts } = useLoveStore();
	const t = useTranslations();

	useEffect(() => {
		if (loveIds.length && product?.id) {
			setIsLove(loveIds.includes(product.id));
		} else {
			setIsLove(false);
		}
	}, [loveIds]);
	const addOrDelLike = (event: React.MouseEvent) => {
		event.stopPropagation(); //
		const id = product?.id;
		if (id) {
			setLoveProducts(id);
		}
	};
	return (
		<i
			onClick={addOrDelLike}
			className={clsx(
				" text-xl text-[#000]",
				isLove ? " ri-heart-fill !text-[#d53a3d]" : "ri-heart-line !text-[#000]",
			)}
		></i>
	);
}
export function IconCompare(props: { product?: any }) {
	let product = props.product;

	const [isCompare, setIsCompare] = useState(false);
	const { compareIds, setcCmpareProducts, changeShow } = useCompareStore();
	const t = useTranslations();

	// console.log(loveIds,'product');
	useEffect(() => {
		if (compareIds.length && product?.id) {
			setIsCompare(compareIds.includes(product.id));
		} else {
			setIsCompare(false);
		}
	}, [compareIds]);
	// 添加对比
	const addOrDelCompare = (event: React.MouseEvent, product) => {
		event.stopPropagation();

		const id = product?.id;
		if (id) {
			setcCmpareProducts(id);
		}

		changeShow(true);
	};
	return (
		<i
			onClick={(e) => addOrDelCompare(e, product)}
			className={clsx(
				" text-xl text-[#000]",
				isCompare ? " ri-delete-bin-fill" : "ri-heart-line !text-[#000]",
			)}
		></i>
	);
}
